<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('accounts')">Cuenta</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.name }}
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Nombre" required/>
          <text-input v-model="form.address" :error="form.errors.address" class="pr-6 pb-8 w-full lg:w-1/2" label="Direción" required/>
          <text-input v-model="form.phone" :error="form.errors.phone" class="pr-6 pb-8 w-full lg:w-1/2" label="Teléfono" />
          <select-input v-model="form.billing" :error="form.errors.billing" class="pr-6 pb-8 w-full lg:w-1/2" label="Facturación">
            <option>Mensual</option>
            <option>Trimestral</option>
            <option>Anual</option>
          </select-input>          
          <select-input v-model="form.country_id" :error="form.errors.country_id" class="pr-6 pb-8 w-full lg:w-1/2" label="País">
            <option v-for="country in countris" :key="country.id" :value="form.country_id">{{ country.name}}</option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Borrar</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Actualizar</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";


export default {
  metaInfo() {
    return {
      title: `${this.form.id}`,
    }
  },
  components: {
    FileInput,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    vSelect,
  },
  layout: Layout,
  props: {
    data: Object,
    countries: Array,
  },
  remember: 'form',
  data() {
    return {
      countris: this.countries,
      form: this.$inertia.form({
        _method: 'put',
        id: this.data.id,
        country_id: this.data.country_id,
        name: this.data.name,
        phone: this.data.phone,
        address: this.data.address,
        billing: this.data.billing,
      }),
    }
  },
  methods: {
     update() {
      this.form.post(this.route('account.update', this.data.id), {
      })
    },
    destroy() {
      if (confirm('Está seguro de Eliminar esta Cuenta?')) {
        this.$inertia.delete(this.route('account.destroy', this.data.id))
      }
    },
    restore() {
      if (confirm('Está seguro de Restaurar esta Cuenta?')) {
        this.$inertia.put(this.route('account.restore', this.data.id))
      }
    },
  },
}
</script>